import script from "./ParsingSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsingSpinner.vue?vue&type=script&setup=true&lang=js"

import "./ParsingSpinner.vue?vue&type=style&index=0&id=2017261c&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2017261c"]])

export default __exports__